import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&题库部分
 *
 */


/**
 * 题库查询：列表
 * @param {*} query
 */
export const examList = (query) => {
  return request({
    url: `${prefix}/exam/list`,
    method: 'get',
    params: query
  })
}

/**
 * 题库查询
 * @param {*} query
 */
export const examOne = (query) => {
  return request({
    url: `${prefix}/exam`,
    method: 'get',
    params: query
  })
}

/**
 * 题库创建
 * @param {*} query
 */
export const examCreate = (query) => {
  return request({
    url: `${prefix}/exam`,
    method: 'post',
    data: query
  })
}

/**
 * 题库修改
 * @param {*} query
 */
export const examUpdate = (query) => {
  return request({
    url: `${prefix}/exam`,
    method: 'put',
    data: query
  })
}

/**
 * 题库修改 多行
 * @param {*} query
 */
export const examsUpdate = (query) => {
  return request({
    url: `${prefix}/exams`,
    method: 'put',
    data: query
  })
}

/**
 * 题库修改状态
 * @param {*} query
 */
export const examUpdateStatus = (query) => {
  return request({
    url: `${prefix}/exam/status`,
    method: 'put',
    data: query
  })
}

/**
 * 题库删除
 * @param {*} query
 */
export const examDestroy = (query) => {
  return request({
    url: `${prefix}/exam`,
    method: 'delete',
    data: query
  })
}

/**
 * 题库删除 真
 * @param {*} query
 */
export const examRemove = (query) => {
  return request({
    url: `${prefix}/exam/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 题库恢复
 * @param {*} query
 */
export const examRestore = (query) => {
  return request({
    url: `${prefix}/exam/restore`,
    method: 'post',
    data: query
  })
}

/**
 * 题库克隆
 * @param {*} query
 */
export const examClone = (query) => {
  return request({
    url: `${prefix}/exam/clone`,
    method: 'post',
    data: query
  })
}

/**
 * 题库章节查询：列表
 * @param {*} query
 */
export const examChapterList = (query) => {
  return request({
    url: `${prefix}/examChapter/list`,
    method: 'get',
    params: query
  })
}

/**
 * 题库章节查询
 * @param {*} query
 */
export const examChapterOne = (query) => {
  return request({
    url: `${prefix}/examChapter`,
    method: 'get',
    params: query
  })
}

/**
 * 题库章节创建
 * @param {*} query
 */
export const examChapterCreate = (query) => {
  return request({
    url: `${prefix}/examChapter`,
    method: 'post',
    data: query
  })
}

/**
 * 题库章节修改
 * @param {*} query
 */
export const examChapterUpdate = (query) => {
  return request({
    url: `${prefix}/examChapter`,
    method: 'put',
    data: query
  })
}

/**
 * 题库章节修改 多行
 * @param {*} query
 */
export const examChaptersUpdate = (query) => {
  return request({
    url: `${prefix}/examChapters`,
    method: 'put',
    data: query
  })
}

/**
 * 题库章节修改状态
 * @param {*} query
 */
export const examChapterUpdateStatus = (query) => {
  return request({
    url: `${prefix}/examChapter/status`,
    method: 'put',
    data: query
  })
}

/**
 * 题库章节删除
 * @param {*} query
 */
export const examChapterDestroy = (query) => {
  return request({
    url: `${prefix}/examChapter`,
    method: 'delete',
    data: query
  })
}

/**
 * 题库试卷查询：列表
 * @param {*} query
 */
export const examPaperList = (query) => {
  return request({
    url: `${prefix}/examPaper/list`,
    method: 'get',
    params: query
  })
}

/**
 * 题库试卷详情
 * @param {*} query
 */
export const examPaperOne = (query) => {
  return request({
    url: `${prefix}/examPaper`,
    method: 'get',
    params: query
  })
}

/**
 * 题库试卷创建
 * @param {*} query
 */
export const examPaperCreate = (query) => {
  return request({
    url: `${prefix}/exam/paper`,
    method: 'post',
    data: query
  })
}

/**
 * 题库试卷修改
 * @param {*} query
 */
export const examPaperUpdate = (query) => {
  return request({
    url: `${prefix}/exam/paper`,
    method: 'put',
    data: query
  })
}

/**
 * 题库试卷删除
 * @param {*} query
 */
export const examPaperDestroy = (query) => {
  return request({
    url: `${prefix}/exam/paper`,
    method: 'delete',
    data: query
  })
}

/**
 * 题库试卷题目查询：列表
 * @param {*} query
 */
export const examPaperItemList = (query) => {
  return request({
    url: `${prefix}/examItem/list`,
    method: 'get',
    params: query
  })
}

/**
 * 题库试卷题目创建
 * @param {*} query
 */
export const examPaperItemCreate = (query) => {
  return request({
    url: `${prefix}/examPaper/item`,
    method: 'post',
    data: query
  })
}

/**
 * 题库试卷题目修改
 * @param {*} query
 */
export const examPaperItemUpdate = (query) => {
  return request({
    url: `${prefix}/examPaper/item`,
    method: 'put',
    data: query
  })
}

/**
 * 题库试卷题目修改 多条
 * @param {*} query
 */
export const examPaperItemsUpdate = (query) => {
  return request({
    url: `${prefix}/examPaper/items`,
    method: 'put',
    data: query
  })
}

/**
 * 题库试卷题目添加引用
 * @param {*} query
 */
export const examPaperItemLink = (query) => {
  return request({
    url: `${prefix}/examPaper/link/item`,
    method: 'post',
    data: query
  })
}

/**
 * 题库试卷题目解除引用
 * @param {*} query
 */
export const examPaperItemUnlink = (query) => {
  return request({
    url: `${prefix}/examPaper/link/item`,
    method: 'delete',
    data: query
  })
}

/**
 * 题库试卷题目删除
 * @param {*} query
 */
export const examPaperItemDestroy = (query) => {
  return request({
    url: `${prefix}/examPaper/item`,
    method: 'delete',
    data: query
  })
}

/**
 * 题库题目修改
 * @param {*} query
 */
export const examItemUpdate = (query) => {
  return request({
    url: `${prefix}/examItem`,
    method: 'put',
    data: query
  })
}

/**
 * 题库题目答案项创建
 * @param {*} query
 */
export const examAnswerCreate = (query) => {
  return request({
    url: `${prefix}/examAnswer`,
    method: 'post',
    data: query
  })
}

/**
 * 题库题目答案项修改
 * @param {*} query
 */
export const examAnswerUpdate = (query) => {
  return request({
    url: `${prefix}/examAnswer`,
    method: 'put',
    data: query
  })
}

/**
 * 题库题目答案项修改：多条
 * @param {*} query
 */
export const examAnswersUpdate = (query) => {
  return request({
    url: `${prefix}/examAnswers`,
    method: 'put',
    data: query
  })
}

/**
 * 题库题目答案项删除
 * @param {*} query
 */
export const examAnswerDestroy = (query) => {
  return request({
    url: `${prefix}/examAnswer`,
    method: 'delete',
    data: query
  })
}
// 知识点详情
export const KnowledgeDetail = (query) => {
  return request({
    url: `${prefix}/readItem/list`,
    method: 'get',
    params: query
  })
}

/**
 * 考试题目（查询详情）
 * @param {*} query
 */
export const examItemOne = (query) => {
  return request({
    url: `${prefix}/examItem`,
    method: 'get',
    params: query
  })
}


/**
 * 考试题目分类（查询列表） 
 * @param {*} query
 */
export const examcategorylist = (query) => {
  return request({
    url: `${prefix}/examItem/category/list`,
    method: 'get',
    params: query
  })
}


/**
 * 题库题目答案项创建
 * @param {*} query
 */
export const examItemcategorycreate = (query) => {
  return request({
    url: `${prefix}/examItem/category`,
    method: 'post',
    data: query
  })
}

/**
 * 试卷（批量修改）
 * @param {*} query
 */
export const exampaperlistUpdate = (query) => {
  return request({
    url: `${prefix}/exam/paper/list`,
    method: 'put',
    data: query
  })
}

/**
 * 错题上报（查询列表）
 * @param {*} query
 */
export const examBugReportlist = (query) => {
  return request({
    url: `${prefix}/examBugReport/list`,
    method: 'get',
    params: query
  })
}


/**
 * 错题上报（查询详情）
 * @param {*} query
 */
export const examBugReportOne = (query) => {
  return request({
    url: `${prefix}/examBugReport`,
    method: 'get',
    params: query
  })
}


/**
 * 错题上报（修改）
 * @param {*} query
 */
export const examBugReportpdate = (query) => {
  return request({
    url: `${prefix}/examBugReport`,
    method: 'put',
    data: query
  })
}
/**
 * 题目导入（导入）
 * @param {*} query
 */
export const byFileImport = (query) => {
  return request({
    url: `${prefix}/examItem/tool/createExamItem/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 题库组合创建
 */
export const examComposeCreate = (query) => {
  return request({
    url: `${prefix}/exam/compose`,
    method: 'post',
    data: query
  })
}
/**
 * 题库组合编辑
 */
export const examComposeEdit = (query) => {
  return request({
    url: `${prefix}/exam/compose`,
    method: 'put',
    data: query
  })
}
/**
 * 题库组合列表
 */
export const examComposeList = (query) => {
  return request({
    url: `${prefix}/exam/compose/list`,
    method: 'get',
    params: query
  })
}
/**
 * 题库组合删除
 */
export const examComposeDestroy = (query) => {
  return request({
    url: `${prefix}/exam/compose`,
    method: 'delete',
    data: query
  })
}



